import client from '../client'

export const getMembershipsKey = `${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/Members/GetMyMemberships`

export async function getMemberships() {
  return client(getMembershipsKey)
}
